module.exports = __webpack_public_path__ + "img/1.a3877d43.jpg";